import React from "react";
import styled from "@emotion/styled";
import DownloadIcon from "@atlaskit/icon/glyph/download";

import { Button } from "../../UI/Button";
import { downloadBlob } from "../../helpers/downloadBlob";

const StyledButton = styled(Button)`
  height: 39px !important;
  align-items: center !important;
`;

interface IProps {
  isDisabled?: boolean;
  apiCall: () => Promise<any>;
}

export const DownloadCSVButton: React.FC<IProps> = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    const response = await props.apiCall();

    downloadBlob(response.blob, response.fileName);

    setIsLoading(false);
  };

  return (
    <StyledButton
      size={39}
      isDisabled={props.isDisabled}
      appearance="primary"
      isLoading={isLoading}
      onClick={handleClick}
      iconBefore={<DownloadIcon label="download" />}
    >
      {props.children}
    </StyledButton>
  );
};

DownloadCSVButton.defaultProps = {
  isDisabled: false,
};
